/* ==========================================================================
   product-quantity-tiers.js
   Append this block to the END of your existing product-premium.js

   WHAT IT DOES
   - Listens for clicks on a tier row (.qty-tiers__row)
   - Marks it selected, checks its radio
   - Sets the value of your product form's quantity input to match
     (1, 2, or 3) so both "Add to cart" and the dynamic "Buy it now"
     button use the right quantity
   - Looks for the quantity input using Dawn's default selector
     (input[name="quantity"] inside the product form). If your buy-box
     snippet uses a different quantity input id/class, update the
     QUANTITY_INPUT_SELECTOR line below to match.
   ========================================================================== */

(function () {
  var QUANTITY_INPUT_SELECTOR = 'form[action*="/cart/add"] input[name="quantity"]';

  document.addEventListener('DOMContentLoaded', function () {
    var tierGroups = document.querySelectorAll('[data-qty-tiers]');

    tierGroups.forEach(function (group) {
      var rows = group.querySelectorAll('[data-tier]');

      rows.forEach(function (row) {
        row.addEventListener('click', function () {
          rows.forEach(function (r) { r.classList.remove('is-selected'); });
          row.classList.add('is-selected');

          var radio = row.querySelector('input[type="radio"]');
          if (radio) radio.checked = true;

          var qty = parseInt(row.getAttribute('data-qty'), 10) || 1;
          var qtyInput = document.querySelector(QUANTITY_INPUT_SELECTOR);

          if (qtyInput) {
            qtyInput.value = qty;
            qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
    });
  });
})();
/* ==========================================================================
   product-premium-extra.js
   Append to the END of your product-premium.js (after the quantity-tiers
   JS block you already added).

   Only does one thing: varies the "N people viewing now" number within
   the min/max range set in product-social-proof.liquid, so it's not a
   dead static number. It does NOT fabricate a fake escalating count —
   it just picks a plausible number in your set range on load and nudges
   it slightly every so often.
   ========================================================================== */

(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var els = document.querySelectorAll('[data-viewer-count]');
    els.forEach(function (el) {
      var wrap = el.closest('[data-min]');
      if (!wrap) return;
      var min = parseInt(wrap.getAttribute('data-min'), 10) || 5;
      var max = parseInt(wrap.getAttribute('data-max'), 10) || 30;

      function randomIn(a, b) {
        return Math.floor(Math.random() * (b - a + 1)) + a;
      }

      el.textContent = randomIn(min, max);

      setInterval(function () {
        el.textContent = randomIn(min, max);
      }, 15000);
    });
  });
})();
